<div class="wrapper-with-header">
  <cpf-header></cpf-header>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

  <cpf-small-nav [showForMobile]="true"></cpf-small-nav>
</div>
